export interface LineProperties {
    width: number;
    color: string;
}

export interface TextProperties {
    font: string;
    fontSize: string;
    color: string;
    textAlign: string;
    textBaseline: string;
}

export interface RectangleProperties {
    borderColor?: string;
    color: string;
}

const BAR_TEXT_PADDING = 3;

export class CanvasController {
    private canvas: HTMLCanvasElement;
    private ctx: CanvasRenderingContext2D;

    constructor(id: string) {
        this.canvas = document.getElementById(id) as HTMLCanvasElement;

        this.ctx = this.canvas.getContext("2d") as CanvasRenderingContext2D;
    }

    getWidth() {
        return this.canvas.width;
    }

    getHeight() {
        return this.canvas.height;
    }

    getCanvas() {
        return this.canvas;
    }

    drawLine(
        x: number,
        y: number,
        x2: number,
        y2: number,
        lineProperties: LineProperties
    ) {
        const ctx = this.ctx;

        ctx.lineWidth = lineProperties.width;
        ctx.strokeStyle = lineProperties.color;
        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.lineTo(x2, y2);
        ctx.stroke();
    }

    drawText(
        text: string,
        x: number,
        y: number,
        textProperties: TextProperties,
        maxWidth: number = 0,
        padding: number = 0
    ) {
        const ctx = this.ctx;

        ctx.fillStyle = textProperties.color;
        ctx.font = `${textProperties.fontSize} ${textProperties.font}`;
        ctx.textAlign = textProperties.textAlign as CanvasTextAlign;
        ctx.textBaseline = textProperties.textBaseline as CanvasTextBaseline;

        if (maxWidth != 0)
            if (ctx.measureText(text).width + padding * 2 > maxWidth) return;

        ctx.fillText(text, x, y);
    }

    drawRoundedRectangle(
        x: number,
        y: number,
        width: number,
        height: number,
        radius: number,
        rectangleProperties: RectangleProperties
    ) {
        const ctx = this.ctx;
        if (rectangleProperties.borderColor)
            ctx.strokeStyle = rectangleProperties.borderColor;
        ctx.beginPath();
        ctx.fillStyle = rectangleProperties.color;

        (ctx as any).roundRect(x, y, width, height, radius);

        ctx.stroke();
        ctx.fill();
    }

    drawRectangle(
        x: number,
        y: number,
        width: number,
        height: number,
        rectangleProperties: RectangleProperties,
        text: string = "",
        textProperties: TextProperties | null = null
    ) {
        const ctx = this.ctx;

        ctx.fillStyle = rectangleProperties.color;
        ctx.fillRect(x, y, width, height);
        if (text) {
            this.drawText(
                text,
                x + width / 2,
                y + height / 2,
                textProperties!,
                width,
                BAR_TEXT_PADDING
            );
        }
    }

    clearCanvas(color: string = "white") {
        const ctx = this.ctx;
        const canvas = this.canvas;

        ctx.fillStyle = color;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
}
